var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"languagepicker",attrs:{"onclick":""}},[_c('a',[_c('li',[_vm._v("\n      "+_vm._s(_vm.$i18n.locale)+"\n    ")])]),_c('a',{on:{"click":_vm.switchLocale}},[_c('li',[_vm._v("\n      "+_vm._s(_vm.otherLocale)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }